import React, { useState, useEffect } from "react";
import "../../styles/admins/inventory.css";
import axios from "axios";
import RiseTicket from "../clients/rise_ticket";

function AddProduct(props) {
  const today = new Date().toISOString().split("T")[0];
  const doShow = props.clientData && props.clientData.is_admin !== 'Techie' && props.clientData.is_admin !== null;
  // const [showPopup, setShowPopup] = useState(false);



  const [formData, setFormData] = useState(
   props.editProd != {} ? 
{
    name: props.editProd?.name || "",
    barcode: props.editProd?.barcode || "",
    category: props.editProd?.category || "Hardware",
    subCategory: props.editProd?.sub_category || "",
    serialNumber: props.editProd?.serial_no || "",
    ssdHdd: props.editProd?.ssd_hdd || "",
    processor: props.editProd?.processor || "",
    remarks: props.editProd?.remarks || "",
    availabilityStatus: props.editProd?.stats || "Available",
    purchaseDate: props.editProd?.pur_date || today,
    expiryDate: props.editProd?.expiry_date || "",
    version: props.editProd?.vers_proc || "",
    ramConfiguration: props.editProd?.key_ram || "",
    licenseType: props.editProd?.lic_type_storage || "",
    macAddress: props.editProd?.mac_no_users || "",
    user_name: props.editProd?.user_name || "",
    added_by: props.clientData && props.clientData.is_admin == null ? null : props.clientData.company_id,
   user_assigned: props.editProd?.assigned_to || "",
  }: null);




  const [nameSuggestions, setNameSuggestions] = useState([]);
  const [filteredName, setFilteredName] = useState([]);
  const [showNameDrop, setShowNameDrop] = useState(false);

  const [subCatSuggestions, setSubCatSuggestions] = useState([]);
  const [filteredSubCat, setFilteredSubCat] = useState([]);
  const [showSubCatDrop, setShowSubCatDrop] = useState(false);
  const [users, setUsers] = useState([]);


  useEffect(() => {
    
    getCompanies(); 
  }, [props]);

//   const getCompanies = async () => {
//       try {
//         const storedUsers = localStorage.getItem("users");

//         if (storedUsers) {
//           setUsers(JSON.parse(storedUsers));
//         } else {
//           const response = await axios.get(
//             "https://api.dectwinservices.com/api/get-user"
//           );


//           if (props.doEdit === 'Techie' || props.doEdit === 'Admin') {
           
//             const filteredUsers = response.data.filter(user =>

//               user.item_id == null ||
//               user.item_id == 0 
//             );

//             setUsers(filteredUsers);
//             localStorage.setItem("users", JSON.stringify(filteredUsers));
//           }

//           // else {
//           //   const filteredUsers = response.data.filter(user =>

//           //     user.item_id == null ||
//           //     user.item_id == 0 ||  user.id == props.editProd.assigned_to
//           //   );

//           //   setUsers(filteredUsers);
//           //   localStorage.setItem("users", JSON.stringify(filteredUsers));
//           // }
//           else {

//   // EDIT MODE -> SHOW ALL USERS
//   if (Object.keys(props.editProd).length !== 0) {

//     setUsers(response.data);

//   } else {

//     // ADD MODE -> ONLY UNASSIGNED USERS
//     const filteredUsers = response.data.filter(
//       (user) => user.item_id == null || user.item_id == 0
//     );

//     setUsers(filteredUsers);
//   }

// }

//         }
//       } catch (e) {
//         props.handleToast({
//           toastMsg:
//             "Something went wrong! Please Refresh page or check internet.",
//           toastColor: "#FF0000",
//         });
//       }
//     };

const getCompanies = async () => {
  try {
    const response = await axios.get(
      "https://api.dectwinservices.com/api/get-user"
    );

    let usersData = response.data;

    // ADD MODE → only unassigned users
    // if (Object.keys(props.editProd).length === 0) {

    //   usersData = usersData.filter(
    //     (user) => user.item_id == null || user.item_id == 0
    //   );

    // }

if(props.clientData.is_admin == 'Techie'){
const filteredUsers = usersData.filter(user =>
    (user.company_id === props.clientData.comp_id || user.company_id === props.clientData.company_id) &&
    user.id !== props.clientData.id
  );
  setUsers(filteredUsers);   
  } else {
   setUsers(usersData);
}


  } catch (e) {
    props.handleToast({
      toastMsg:
        "Something went wrong! Please Refresh page or check internet.",
      toastColor: "#FF0000",
    });
  }
};

  const handleSelect = (name, value) => {
    setFormData({ ...formData, [name]: value });
    setShowNameDrop(false);
    setShowSubCatDrop(false);
  };

  useState(() => {
    const fetchProduct = async () => {
      const product = await axios.get(
        `https://api.dectwinservices.com/api/user-product/${props.clientData.id}`
      );
      if (product.data.length < 1) {
        return;
      }
  
// if(product.data != [])
      setFormData({
        name: product.data[0]?.name || "",
        barcode: product.data[0]?.barcode || "",
        category: product.data[0].category || "Hardware",
        subCategory: product.data[0].sub_category || "",
        serialNumber: product.data[0].serial_no || "",
        ssdHdd: product.data[0].ssd_hdd || "",
        processor: product.data[0].processor || "",
        remarks: product.data[0].remarks || "",
        availabilityStatus: product.data[0].stats || "Available",
        purchaseDate: product.data[0].pur_date || today,
        expiryDate: product.data[0].expiry_date || "",
        version: product.data[0].vers_proc || "",
        ramConfiguration: product.data[0].key_ram || "",
        licenseType: product.data[0].lic_type_storage || "",
        macAddress: product.data[0].mac_no_users || "",
        user_name: product.data[0].user_name || "",
        added_by: props.clientData.company_id,
        user_assigned:product.data[0].assigned_to || "",
      });
    };
    if (!doShow) {
      try {
        fetchProduct();
      } catch (e) {
        props.handleToast({
          toastMsg:
            "Something went wrong! Please Refresh page or check internet.",
          toastColor: "#FF0000",
        });
      }
    }
    const getProducts = async () => {
      try {
        const storedProducts = localStorage.getItem("products");

        if (storedProducts) {
          const parsedProducts = JSON.parse(storedProducts);
          const productNames = [
            ...new Set(parsedProducts.map((product) => product.name)),
          ];
          setNameSuggestions(productNames);
          const productSubCats = [
            ...new Set(parsedProducts.map((product) => product.sub_category)),
          ];
          setSubCatSuggestions(productSubCats);
        } else {
          const response = await axios.get(
            "https://api.dectwinservices.com/api/products"
          );
          const productNames = [
            ...new Set(response.data.map((product) => product.name)),
          ];
          setNameSuggestions(productNames);
          const productSubCats = [
            ...new Set(response.data.map((product) => product.sub_category)),
          ];
          setSubCatSuggestions(productSubCats);
          localStorage.setItem("products", JSON.stringify(response.data));
        }
      } catch (e) {
        props.handleToast({
          toastMsg:
            "Something went wrong! Please Refresh page or check internet.",
          toastColor: "#FF0000",
        });
      }
    };
    getProducts();
  });

  const handleChange = (e) => {
    const value = e.target.value;
    setFormData({ ...formData, [e.target.name]: value });

    if (e.target.name !== "name" && e.target.name !== "subCategory") {
      return;
    }

    if (value) {
      if (e.target.name === "name") {
        const filtered = nameSuggestions.filter((item) =>
          item.toLowerCase().includes(value.toLowerCase())
        );
        setFilteredName(filtered);
        setShowNameDrop(true);
      } else {
        const filtered = subCatSuggestions.filter((item) =>
          item.toLowerCase().includes(value.toLowerCase())
        );
        setFilteredSubCat(filtered);
        setShowSubCatDrop(true);
      }
    } else {
      setShowNameDrop(false);
      setShowSubCatDrop(false);
    }
  };

  // Submit form data
  // const handleSubmit = async (e) => {
  //   e.preventDefault();
  //   props.handleLoading();
  //   try {
  //     if (Object.keys(props.editProd).length === 0) {
  //       await axios.post(
  //         "https://api.dectwinservices.com/api/add-product",
  //         formData
  //       );
  //       props.handleToast({
  //         toastMsg: "Product Added Successfully!!!",
  //         toastColor: "#4CAF50",
  //       });
  //     } else {
  //       await axios.put(
  //         `https://api.dectwinservices.com/api/update-product/${props.editProd.prod_id}`,
  //         formData
  //       );
  //       props.handleToast({
  //         toastMsg: "Product Updated Successfully!!!",
  //         toastColor: "#4CAF50",
  //       });
  //     }
  //     localStorage.removeItem("products");
  //     window.location.reload();
  //   } catch (error) {
  //     props.handleToast({
  //       toastMsg: "Something went wrong! Please check data or internet.",
  //       toastColor: "#FF0000",
  //     });
  //   }
  //   props.closeLoading();
  // };

  const handleSubmit = async (e) => {

  e.preventDefault();

  props.handleLoading();

  try {

    let prodId = null;

    // ADD PRODUCT
    if (Object.keys(props.editProd).length === 0) {

      const response = await axios.post(
        "https://api.dectwinservices.com/api/add-product",
        formData
      );

      // get new product id
      prodId = response.data.prod_id;

      props.handleToast({
        toastMsg: "Product Added Successfully!!!",
        toastColor: "#4CAF50",
      });

    } else {

      // EDIT PRODUCT
      await axios.put(
        `https://api.dectwinservices.com/api/update-product/${props.editProd.prod_id}`,
        formData
      );

      prodId = props.editProd.prod_id;

      props.handleToast({
        toastMsg: "Product Updated Successfully!!!",
        toastColor: "#4CAF50",
      });
    }

    // CALL ASSIGN USER IN BOTH CASES
    if (formData.user_assigned) {
      await handleAssignUser(prodId);
    }

    localStorage.removeItem("products");

    window.location.reload();

  } catch (error) {

    props.handleToast({
      toastMsg: "Something went wrong!",
      toastColor: "#FF0000",
    });

  }

  props.closeLoading();
};


  // const handleAssignUser = async () => {
  //   if (!formData.user_assigned) return;

  //   props.handleLoading();
  //   try {
  //     await axios.put(
  //       `https://api.dectwinservices.com/api/assign-user/${props.editProd.prod_id}`,
  //       { user_id: formData.user_assigned }
  //     );

  //     // props.handleToast({
  //     //   toastMsg: "User assigned successfully!",
  //     //   toastColor: "#4CAF50",
  //     // });

  //     // window.location.reload();

  //   } catch (error) {
  //     props.handleToast({
  //       toastMsg: "Failed to assign user. Please try again.",
  //       toastColor: "#FF0000",
  //     });
  //   }
  //   props.closeLoading();
  // };


  const handleAssignUser = async (prodId) => {

  if (!formData.user_assigned) return;

  await axios.put(
    `https://api.dectwinservices.com/api/assign-user/${prodId}`,
    {
      user_id: formData.user_assigned,
    }
  );
};

  return (
    <section className="px-3">
      <div className="d-md-flex justify-between my-3">
        <div className="d-flex">
          {doShow ? (
            <i className="bx bxs-customize" style={{ fontSize: "24px" }}></i>
          ) : (
            <i className="bx bxs-plus-circle" style={{ fontSize: "24px" }}></i>
          )}
          <p className="fw-bolder fs-big">
            &nbsp;
            {doShow
              ? "Raise A Ticket"
              : Object.keys(props.editProd).length === 0
                ? "Add New Product"
                : `Edit Product "${props.editProd.name}"`}
          </p>
        </div>
        {!doShow && (
          <button className="add-btn" onClick={props.toggler}>
            <i
              className="bx bxs-left-arrow-circle"
              style={{ fontSize: "22px" }}
            ></i>
            &nbsp; Back to Inventory
          </button>
        )}


      </div>
      {!doShow &&
        <div className="p-3 bg-white">

          <form className="row" onSubmit={handleSubmit}>
                
                 <div
              className="form-data col-lg-3 col-md-6 col-12"
  >
    <label htmlFor="user_assigned">Select User</label>

    <div className="d-flex">
      <div className="input-icon" style={{ width: '100%' }}>
        <i className="bx bx-package"></i>

        <select
          name="user_assigned"
          id="user_assigned"
          value={formData.user_assigned || ""}
          onChange={handleChange}
          disabled={doShow}
          style={{ width: '100%' }}
        >
          <option value="">Select User</option>

          {users.map((user) => (
            <option key={user.id} value={user.id}>
              {user.name}
            </option>
          ))}
        </select>
      </div>

      &nbsp;&nbsp;

    </div>
  </div>


            <div
              className="form-data col-lg-3 col-md-6 col-12"
            >
              <label htmlFor="name">Product Name</label>
              <div className="input-icon">
                <i className="bx bxs-layer"></i>
                <input
                  type="text"
                  name="name"
                  id="name"
                  value={formData.name}
                  onChange={handleChange}
                  placeholder="Product Name"
                  disabled={doShow}
                  required
                />
              </div>
              {showNameDrop && filteredName.length > 0 && (
                <ul
                  style={{
                    position: "absolute",
                    width: "100%",
                    background: "white",
                    listStyle: "none",
                    margin: 0,
                    padding: "5px",
                    border: "1px solid #ccc",
                    borderRadius: "4px",
                    maxHeight: "150px",
                    overflowY: "auto",
                    top: "75px",
                    boxShadow: "0px 4px 6px rgba(0,0,0,0.1)",
                    zIndex: 1000,
                  }}
                >
                  {filteredName.map((item, index) => (
                    <li
                      key={index}
                      onClick={() => handleSelect("name", item)}
                      style={{
                        padding: "8px",
                        cursor: "pointer",
                        borderBottom:
                          index !== filteredName.length - 1
                            ? "1px solid #eee"
                            : "none",
                      }}
                    >
                      {item}
                    </li>
                  ))}
                </ul>
              )}
            </div>

            <div className="form-data col-lg-3 col-md-6 col-12">
              <label htmlFor="barcode">Asset Code</label>
              <div className="input-icon">
                <i className="bx bx-barcode"></i>
                <input
                  type="text"
                  name="barcode"
                  id="barcode"
                  value={formData.barcode}
                  onChange={handleChange}
                  placeholder="Asset Code"
                  disabled={doShow}
                  required
                />
              </div>
            </div>

            <div className="form-data col-lg-3 col-md-6 col-12">
              <label htmlFor="category">Category</label>
              <div className="input-icon">
                <i className="bx bxs-category-alt"></i>
                <select
                  name="category"
                  id="category"
                  value={formData.category}
                  onChange={handleChange}
                  disabled={doShow}
                >
                  <option value="Hardware">Hardware</option>
                  <option value="Software">Software</option>
                </select>
              </div>
            </div>

            <div
              className="form-data col-lg-3 col-md-6 col-12"
            >
              <label htmlFor="subCategory">Sub-Category</label>
              <div className="input-icon">
                <i className="bx bx-git-merge"></i>
                <input
                  type="text"
                  name="subCategory"
                  id="subCategory"
                  value={formData.subCategory}
                  onChange={handleChange}
                  placeholder="Sub Category"
                  disabled={doShow}
                  required
                />
              </div>
              {showSubCatDrop && filteredSubCat.length > 0 && (
                <ul
                  style={{
                    position: "absolute",
                    width: "100%",
                    background: "white",
                    listStyle: "none",
                    margin: 0,
                    padding: "5px",
                    border: "1px solid #ccc",
                    borderRadius: "4px",
                    maxHeight: "150px",
                    overflowY: "auto",
                    top: "75px",
                    boxShadow: "0px 4px 6px rgba(0,0,0,0.1)",
                    zIndex: 1000,
                  }}
                >
                  {filteredSubCat.map((cats, index) => (
                    <li
                      key={index}
                      onClick={() => handleSelect("subCategory", cats)}
                      style={{
                        padding: "8px",
                        cursor: "pointer",
                        borderBottom:
                          index !== filteredSubCat.length - 1
                            ? "1px solid #eee"
                            : "none",
                      }}
                    >
                      {cats}
                    </li>
                  ))}
                </ul>
              )}
            </div>

            <div className="form-data col-lg-3 col-md-6 col-12">
              <label htmlFor="serialNumber">Serial Number</label>
              <div className="input-icon">
                <i className="bx bx-unite"></i>
                <input
                  type="text"
                  name="serialNumber"
                  id="serialNumber"
                  placeholder="Serial Number"
                  value={formData.serialNumber}
                  onChange={handleChange}
                  disabled={doShow}
                />
              </div>
            </div>

            <div className="form-data col-lg-3 col-md-6 col-12">
              <label htmlFor="availabilityStatus">Availability Status</label>
              <div className="input-icon">
                <i className="bx bx-package"></i>
                <select
                  name="availabilityStatus"
                  id="availabilityStatus"
                  value={formData.availabilityStatus}
                  onChange={handleChange}
                  disabled={doShow}
                >
                  <option value="Available">Available</option>
                  <option value="In Use">In Use</option>
                  <option value="Under Repair">Under Repair</option>
                  <option value="Decommissioned">Decommissioned</option>
                </select>
              </div>
            </div>

            <div className="form-data col-lg-3 col-md-6 col-12">
              <label htmlFor="purchaseDate">Purchase Date</label>
              <div className="input-icon">
                <i className="bx bxs-calendar-check"></i>
                <input
                  type="date"
                  name="purchaseDate"
                  id="purchaseDate"
                  value={formData.purchaseDate}
                  onChange={handleChange}
                  disabled={doShow}
                />
              </div>
            </div>

            <div className="form-data col-lg-3 col-md-6 col-12">
              <label htmlFor="expiryDate">Validity Tenure (in Months)</label>
              <div className="input-icon">
                <i className="bx bxs-calendar-x"></i>
                <input
                  type="number"
                  name="expiryDate"
                  id="expiryDate"
                  value={formData.expiryDate}
                  onChange={handleChange}
                  placeholder="Tenure in Months"
                  disabled={doShow}
                />
              </div>
            </div>

            <div className="form-data col-lg-3 col-md-6 col-12">
              <label htmlFor="version">Product Version</label>
              <div className="input-icon">
                <i className="bx bxs-buoy"></i>
                <input
                  type="text"
                  name="version"
                  id="version"
                  placeholder="Product Verion"
                  value={formData.version}
                  onChange={handleChange}
                  disabled={doShow}
                />
              </div>
            </div>

            <div className="form-data col-lg-3 col-md-6 col-12">
              <label htmlFor="ramConfiguration">RAM Configuration</label>
              <div className="input-icon">
                <i className="bx bx-hdd"></i>
                <input
                  type="text"
                  name="ramConfiguration"
                  id="ramConfiguration"
                  placeholder="RAM Configuration"
                  value={formData.ramConfiguration}
                  onChange={handleChange}
                  disabled={doShow}
                />
              </div>
            </div>

            <div className="form-data col-lg-3 col-md-6 col-12">
              <label htmlFor="ssdHdd">SSD/HDD Configuration</label>
              <div className="input-icon">
                <i className="bx bxs-data"></i>
                <input
                  type="text"
                  name="ssdHdd"
                  id="ssdHdd"
                  placeholder="SSD/HDD Configuration"
                  value={formData.ssdHdd}
                  onChange={handleChange}
                  disabled={doShow}
                />
              </div>
            </div>

            <div className="form-data col-lg-3 col-md-6 col-12">
              <label htmlFor="processor">Processor</label>
              <div className="input-icon">
                <i className="bx bx-chip"></i>
                <input
                  type="text"
                  name="processor"
                  id="processor"
                  placeholder="Processor"
                  value={formData.processor}
                  onChange={handleChange}
                  disabled={doShow}
                />
              </div>
            </div>

            <div className="form-data col-lg-3 col-md-6 col-12">
              <label htmlFor="licenseType">Operating System</label>
              <div className="input-icon">
                <i className="bx bxs-data"></i>
                <input
                  type="text"
                  name="licenseType"
                  id="licenseType"
                  placeholder="Operating System"
                  value={formData.licenseType}
                  onChange={handleChange}
                  disabled={doShow}
                />
              </div>
            </div>

            <div className="form-data col-lg-3 col-md-6 col-12">
              <label htmlFor="macAddress">MAC Address</label>
              <div className="input-icon">
                <i className="bx bx-hash"></i>
                <input
                  type="text"
                  name="macAddress"
                  id="macAddress"
                  placeholder="MAC Address"
                  value={formData.macAddress}
                  onChange={handleChange}
                  disabled={doShow}
                />
              </div>
            </div>

            <div className="form-data col-lg-3 col-md-6 col-12">
              <label htmlFor="vendorDetails">Manufactured By</label>
              <div className="input-icon">
                <i className="bx bxs-user-detail"></i>
                <input
                  type="text"
                  name="user_name"
                  id="user_name"
                  placeholder="Manufactured By"
                  value={formData.user_name}
                  onChange={handleChange}
                  disabled={doShow}
                />
              </div>
            </div>

            <div className="form-data col-lg-3 col-md-6 col-12">
              <label htmlFor="remarks">Remarks</label>
              <div className="input-icon">
                <i className="bx bxs-notepad"></i>
                <input
                  type="text"
                  name="remarks"
                  id="remarks"
                  placeholder="Enter Remarks"
                  value={formData.remarks}
                  onChange={handleChange}
                  disabled={doShow}
                />
              </div>
            </div>
         <div className="btn-group d-flex mt-2" style={{ justifyContent: "end" }}>

            <button type="submit" className="button-85">
              Submit
            </button>
</div>

          </form>


          {Object.keys(props.editProd).length != 0 &&
            <>

            </>}
{/* 
          <div className="form-data" style={{ paddingLeft: '0.7em', paddingRight: '0.7em' }}>
            <label htmlFor="user_assigned">Select User</label>

            <div className="d-flex">
              <div className="input-icon" style={{ width: '25%' }}>
                <i className="bx bx-package"></i>
                <select
                  name="user_assigned"
                  id="user_assigned"
                  value={formData.user_assigned || ""}
                  onChange={handleChange}
                  disabled={doShow}
                >
                  <option value="">Select User</option>
                  {users.map((user) => (
                    <option key={user.id} value={user.id}>
                      {user.name}
                    </option>
                  ))}
                </select>
              </div>

              &nbsp;&nbsp;

              {formData.user_assigned && (
                <button
                  type="button"
                  className="button-85"
                  onClick={handleAssignUser}
                  style={{ padding: '1em 2em' }}
                >
                  Assign User
                </button>
              )}

            </div>
          </div> */}

        </div>
      }



      {doShow && (
        <>
          <div className="assigned-row">




            <RiseTicket
              // onClose={() => setShowPopup(false)}
              product={formData}
              user={props.clientData}
              handleToast={props.handleToast}
            />
            {/* )} */}
          </div>
        </>
      )}

    </section>
  );
}

export default AddProduct;
